import { observer } from 'mobx-react-lite'
import { Menu } from 'shared/ui'
import { TrialProgress } from 'entities/Subscription/ui/TrialProgress'
import { SegmentMenu } from 'pages/contacts/ui/ContactsMenu/ui/SegmentMenu/SegmentMenu'

export const ContactsMenuContent = observer(() => {
  return <Menu title='Contacts' menuContent={<SegmentMenu />} bottomNode={<TrialProgress />} />
})
